import { render, staticRenderFns } from "./SubscriptionPeriodList.vue?vue&type=template&id=a086304c&"
import script from "./SubscriptionPeriodList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPeriodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports